/*export const environment = {
    production: false,
    SUrlgApi: "https://localhost:44313/api/v1/",
    sUrlAuth: "http://localhost:5286/api/"
};*/

export const environment = {
    production: false,
    SUrlgApi: "https://beta.apicomercial.sw-hmp.com/api/v1/",
    //SUrlgApi: "https://beta.apicomercial2.sw-hmp.com/api/v1/",
    //SUrlgApi: "https://localhost:7095/api/v1/",
    //SUrlgApi: "https://localhost:7095/api/v1/",
    sUrlAuthLocal: "https://beta.apiauth.sw-hmp.com/api/",
    SUrlgApiLocal: "https://localhost:7095/api/v1/",
    sUrlAuth: "https://beta.apiauth.sw-hmp.com/api/",
    sUrlReciboNomina: "https://beta.recibonomina.sw-hmp.com/api/v1/",
    sUrlNApi: "https://beta.n.api.comercial.sw-hmp.com/api/v1/" 
    //sUrlNApi: "https://beta.n.api.comercial.sw-hmp.com/api/v1/" 
};

